<template>
  <v-sheet outlined class="pa-4">
    <div class="d-flex align-center mb-1">
      <h3 class="flex-grow-1">Motivos de anulación</h3>
      <v-btn small color="primary" depressed @click="nuevo"><v-icon small left>mdi-plus</v-icon>Agregar motivo</v-btn>
    </div>
    <p class="grey--text text--darken-1 mb-4">
      Con estos motivos se anula o rechaza un pedido. Cada restaurante maneja distinto al cliente que se va, la
      cortesía o el producto agotado: deja los que usas y apaga los demás. Lo que elijas en «Qué pasa con lo
      perdido» queda guardado en el pedido anulado y sale en los reportes; el efecto sobre el inventario llegará
      después.
    </p>

    <div v-if="cargando" class="text-center grey--text py-6">Cargando…</div>
    <v-list v-else class="pa-0">
      <template v-for="(m, i) in motivos">
        <v-list-item :key="m.id" class="px-0">
          <v-list-item-content>
            <v-list-item-title :class="{ 'grey--text': !m.active }">
              {{ m.name }}
              <v-chip x-small outlined class="ml-2" v-if="m.requires_note">Pide nota</v-chip>
              <v-chip x-small class="ml-1" v-if="!m.active">Apagado</v-chip>
            </v-list-item-title>
            <v-list-item-subtitle>{{ etiquetaTratamiento(m.treatment) }}</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action class="flex-row align-center">
            <v-switch :input-value="m.active" dense hide-details class="mt-0 mr-2" @change="alternar(m, $event)"
              :title="m.active ? 'Apagar' : 'Encender'"></v-switch>
            <v-btn icon @click="editar(m)" title="Editar"><v-icon>mdi-pencil-outline</v-icon></v-btn>
          </v-list-item-action>
        </v-list-item>
        <v-divider v-if="i < motivos.length - 1" :key="'d' + m.id"></v-divider>
      </template>
    </v-list>
    <div class="red--text caption mt-2" v-if="error">{{ error }}</div>

    <v-dialog v-model="dialogo" max-width="460" persistent>
      <v-card>
        <v-card-title class="text-h6">{{ form.id ? "Editar motivo" : "Nuevo motivo" }}</v-card-title>
        <v-card-text>
          <v-text-field v-model="form.name" label="Nombre del motivo" outlined dense maxlength="80"></v-text-field>
          <v-select v-model="form.treatment" :items="tratamientos" item-text="texto" item-value="valor"
            label="Qué pasa con lo perdido" outlined dense :hint="descripcionTratamiento" persistent-hint></v-select>
          <v-switch v-model="form.requires_note" label="Pedir una nota al usarlo" dense class="mt-4"></v-switch>
          <v-switch v-model="form.active" label="Disponible en el POS" dense></v-switch>
          <div class="red--text caption" v-if="errorForm">{{ errorForm }}</div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text :disabled="guardando" @click="dialogo = false">Cancelar</v-btn>
          <v-btn color="primary" depressed :loading="guardando" :disabled="form.name.trim().length < 2" @click="guardar">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-sheet>
</template>
<script>
const TRATAMIENTOS = [
  { valor: "none", texto: "Sin efecto en inventario", detalle: "Se anuló antes de preparar, o no hay nada que registrar." },
  { valor: "inventory_loss", texto: "Registrar como pérdida", detalle: "La comida ya se preparó o se consumió; es una pérdida del local." },
  { valor: "receivable", texto: "Dejar por cobrar", detalle: "Se le cobrará después a un cliente conocido." },
  { valor: "charge_waiter", texto: "Marcar para descontar al responsable", detalle: "Solo se marca: el descuento lo hace la nómina, no el POS." },
];

export default {
  name: "MotivosDeAnulacion",
  data: () => ({
    motivos: [],
    cargando: false,
    error: "",
    dialogo: false,
    guardando: false,
    errorForm: "",
    tratamientos: TRATAMIENTOS,
    form: { id: null, name: "", treatment: "none", requires_note: false, active: true },
  }),
  computed: {
    descripcionTratamiento() {
      const t = TRATAMIENTOS.find((x) => x.valor === this.form.treatment);
      return t ? t.detalle : "";
    },
  },
  mounted() {
    this.cargar();
  },
  methods: {
    etiquetaTratamiento(valor) {
      const t = TRATAMIENTOS.find((x) => x.valor === valor);
      return t ? t.texto : valor;
    },
    async cargar() {
      this.cargando = true;
      this.error = "";
      try {
        const r = await this.$http.get("api/v1/pos/motivos-de-anulacion", { todos: 1 });
        this.motivos = (r && r.items) || [];
      } catch (e) {
        this.error = "No se pudieron cargar los motivos.";
      } finally {
        this.cargando = false;
      }
    },
    nuevo() {
      this.form = { id: null, name: "", treatment: "none", requires_note: false, active: true };
      this.errorForm = "";
      this.dialogo = true;
    },
    editar(m) {
      this.form = { id: m.id, name: m.name, treatment: m.treatment, requires_note: !!m.requires_note, active: !!m.active };
      this.errorForm = "";
      this.dialogo = true;
    },
    async enviar(datos) {
      const ruta = "api/v1/pos/motivos-de-anulacion" + (datos.id ? "/" + datos.id : "");
      return this.$http.post(ruta, { name: datos.name.trim(), treatment: datos.treatment, requires_note: datos.requires_note, active: datos.active });
    },
    async guardar() {
      this.guardando = true;
      this.errorForm = "";
      try {
        const r = await this.enviar(this.form);
        if (r && r.success) {
          this.dialogo = false;
          await this.cargar();
        } else {
          this.errorForm = (r && (r.message || r.msg)) || "No se pudo guardar.";
        }
      } catch (e) {
        this.errorForm = (e && (e.message || e.msg)) || "No se pudo guardar. Revisa el nombre e inténtalo de nuevo.";
      } finally {
        this.guardando = false;
      }
    },
    async alternar(m, activo) {
      try {
        await this.enviar({ id: m.id, name: m.name, treatment: m.treatment, requires_note: !!m.requires_note, active: !!activo });
      } finally {
        await this.cargar();
      }
    },
  },
};
</script>
